<template>
  <MainLayout>
    <b-row id="topGavContainer">
      <b-col
        class="shadow-sm"
        style
      >
        <b-card-body>
          <u-error-handling
            v-if="errorObject"
            :error-object="errorObject"
          />

          <h4
            class="card-title font-weight-bold"
            style="margin-bottom: 40px"
          >
            Top GAV
          </h4>

          <u-loader v-if="isLoading" />
          <draggable
            v-else
            v-model="topGavs"
            class="pb-4"
            group="people"
            v-bind="dragOptions"
            @start="drag = true"
            @end="drag = false"
          >
            <transition-group
              type="transition"
              name="draggablePanelTransition"
            >
              <div
                v-for="(element, index) in topGavs"
                :key="element.id"
                class="panel panel-info draggablePanelItem"
              >
                <div class="panel-heading">
                  {{ element.contractNumber }} - {{ element.contractName }}
                </div>
                <i
                  style="font-size: 18px; margin-right: 9px"
                  class="fas fa-arrows-alt"
                />
                <button
                  v-b-tooltip.hover.bottom
                  style="
                    font-size: 14px;
                    padding: 0px 6px;
                    margin-top: -7px;
                    overflow: hidden;
                  "
                  class="btn btn-danger"
                  positioning="bottom"
                  title="Vertrag aus der Top-Liste entfernen"
                  @click="removeGavFromList(index)"
                >
                  <i class="fas fa-times" />
                </button>
              </div>
            </transition-group>
          </draggable>
          <h5 class="mt-4 mb-2">
            Vertrag der TOP-Liste hinzufügen
          </h5>
          <b-alert
            :show="contractAlreadyInTopGav"
            variant="info"
            style="width: calc(100% - 200px); font-size: 15px"
          >
            Vertrag ist bereits in der Top-GAV Liste
            <i
              style="font-size: 19px"
              class="float-right fas fa-times large"
              @click="contractAlreadyInTopGav = false"
            />
          </b-alert>
          <div class="autocompleteWrapper">
            <div
              id="anchorForMultiselect"
              style="width: 100%; height: 1px; position: relative; top: 4px"
            />
            <v-autocomplete
              v-model="selectedGav"
              item-text="title"
              :disabled="allGavLoading"
              placeholder="Suche nach Titel oder Vertrags-Nummer"
              :filter="myFilter"
              attach="#anchorForMultiselect"
              return-object
              :items="allAvailableGavs"
              @change="addGavSelectionChanged"
            >
              <span
                slot="no-data"
                class="m-2"
              >Keine Verträge gefunden</span>
              <template
                slot="selection"
                slot-scope="data"
                style="overflow: hidden"
              >
                <span>{{ data.item.contractNumber }} -
                  {{ data.item.contractName }}</span>
              </template>
              <template
                slot="item"
                slot-scope="data"
              >
                {{ data.item.contractNumber }} - {{ data.item.contractName }}
              </template>
            </v-autocomplete>
          </div>
          <b-button
            v-b-tooltip.hover.bottom
            variant="primary"
            class="mb-4"
            positioning="bottom"
            title="Ausgewählter Vertrag zu Top Liste hinzufügen"
            :disabled="selectedGav == null"
            @click="addSelectedGav"
          >
            <i
              style="font-size: 18px"
              class="fas fa-plus large"
            />
          </b-button>

          <b-modal
            id="confirmUndoChanges"
            ref="confirmUndoChanges"
            hide-footer
            title="Änderungen verwerfen"
            no-fade
          >
            <div class="d-block mb-4">
              Sind Sie sicher, dass Sie alle Änderungen rückgängig machen
              wollen?
            </div>
            <b-button
              variant="success"
              @click="reloadTopGavs"
            >
              Ok
            </b-button>
            <b-button
              class="ml-2"
              variant
              @click="hideModal"
            >
              Abbrechen
            </b-button>
          </b-modal>
          <div class="buttonContainer">
            <b-button
              class
              variant="success"
              @click="SaveTopGav"
            >
              Speichern
            </b-button>
            <b-button
              v-b-modal.confirmUndoChanges
              class="ml-2"
              variant="danger"
            >
              Abbrechen
            </b-button>
          </div>
        </b-card-body>
      </b-col>
    </b-row>
    <div style="height: 500px" />
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import draggable from "vuedraggable";
import {
  GetAllContractsNoVersions,
  GetTopGavs,
  SaveTopGavs,
} from "@/services/contract.service.js";

export default {
  components: {
    MainLayout,
    draggable,
  },
  data() {
    return {
      isLoading: false,
      errorObject: null,
      allGavLoading: true,
      topGavs: [],
      allAvailableGavs: [],
      selectedGav: null,
      contractAlreadyInTopGav: false,
      myFilter: (option, search) => {
        let temp = search.toLowerCase();
        return (
          option.contractNumber.toLowerCase().indexOf(temp) > -1 ||
          option.contractName.toLowerCase().indexOf(temp) > -1
        );
      },
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  mounted() {
    this.isLoading = true;
    this.errorObject = null;
    this.allGavLoading = true;

    GetAllContractsNoVersions(
      (response) => {
        this.allAvailableGavs = response.data;
        this.allGavLoading = false;
      },
      (error) => {
        this.allGavLoading = false;
        this.errorObject = error;
      },
    );

    this.GetTopGav();
  },
  methods: {
    removeGavFromList(index) {
      this.topGavs.splice(index, 1);
    },
    hideModal() {
      this.$refs["confirmUndoChanges"].hide();
    },
    addGavToTopGav() {
      this.topGavs.push(this.allAvailableGavs[0]);
    },
    addSelectedGav() {
      if (
        this.topGavs.filter((item) => {
          return item.id == this.selectedGav.id;
        }).length != 0
      ) {
        this.contractAlreadyInTopGav = true;
        return;
      }
      this.topGavs.push(this.selectedGav);
    },
    addGavSelectionChanged() {
      this.contractAlreadyInTopGav = false;
    },
    reloadTopGavs() {
      this.GetTopGav();
      this.hideModal();
    },
    GetTopGav() {
      this.isLoading = true;
      this.errorObject = null;

      GetTopGavs(
        (response) => {
          this.topGavs = response.data;
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    SaveTopGav() {
      this.isLoading = true;
      this.errorObject = null;
      SaveTopGavs(
        this.topGavs,
        () => {
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
  },
};
</script>

<style>
#topGavContainer .v-select {
  border-radius: 0;
  width: calc(100% - 241px);
  float: left;
  padding: 0.25rem 0.5rem;
  font-size: 16px;
  color: #212529;
}
#topGavContainer .v-select {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  color: #212529;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

#topGavContainer .v-select {
  border-radius: 0;
  width: calc(100% - 250px);
  margin-bottom: 50px;
  padding: 0px;
  margin-right: 12px;
}

#topGavContainer .v-list__tile {
  height: auto;
  padding-bottom: 12px;
}
#topGavContainer .v-select__slot {
  overflow: hidden;
}
</style>

<style scoped>
.draggablePanelItem {
  background-color: #3e3e3e;
  color: white;
  width: 100%;
  padding: 10px;
  margin-bottom: 7px;
  cursor: move;
  width: calc(100% - 200px);
  overflow: hidden;
}

.buttonContainer {
  width: calc(100% - 250px);
}

.sortable-ghost {
  opacity: 0;
}

.ghost {
  background: #8b8b8b;
}

.panel-heading {
  display: inline-block;
  width: calc(100% - 52px);
}

.draggablePanelTransition-enter-active,
.draggablePanelTransition-leave-active {
  transition: all 0.3s;
}
.draggablePanelTransition-enter,
.draggablePanelTransition-leave-to {
  width: 0;
  height: 0;
  padding: 0;
  margin-bottom: 0px;
}
.draggablePanelTransition-enter-to,
.draggablePanelTransition-leave {
  opacity: 1;
  height: 40px;
  margin-bottom: 7px;
}
</style>
